module.exports = __webpack_public_path__ + "static/receipt_management-cd6d6b0d74ef0492ed93d5e305842094.png";